module.exports = __webpack_public_path__ + "img/ideation-01-banner.ec895cf7.jpg";